/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IEspecialty } from 'app/shared/model/especialty.model';
import { IDepartment } from 'app/shared/model/department.model';

export interface IDepartmentSpeciality {
  id?: string;
  active?: boolean | null;
  cursor?: number | null;
  lastUpdate?: number | null;
  microSec?: number | null;
  timestampEntry?: number | null;
  speciality?: IEspecialty | null;
  department?: IDepartment | null;
}

export const defaultValue: Readonly<IDepartmentSpeciality> = {
  active: false,
};
